// extracted by mini-css-extract-plugin
export default {"virtualTable":"VirtualizedTableList_virtualTable__QxRog"};